import Box from "@vapor/react-material/Box";
import CssBaseline from "@vapor/react-material/CssBaseline";
import { BrowserRouter } from "react-router-dom";

import { LayoutRoutes } from "../components/LayoutRoutes";
import { UIShell } from "../components/UIShell";
import { useLayout } from "../state/use-layout";

import { createComponents } from "../../utils/create-components";
import { Gate } from "../../service-gates";

export const Layout = () => {
  const { isEmbed, routes, toolbar, title, baseName } = useLayout();

  // Embed mode - Pure routing
  if (isEmbed) {
    return (
      <BrowserRouter basename={baseName}>
        <Box
          sx={{
            position: "absolute",
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
            display: "flex",
            flexDirection: "column"
          }}
        >
          <CssBaseline />
          <Gate id="embed" />
          <Gate id="main" />
          {createComponents(routes.before)}
          <LayoutRoutes items={routes.items} />
          {createComponents(routes.after)}
        </Box>
      </BrowserRouter>
    );
  }

  // Layout Mode - full UI
  return (
    <BrowserRouter basename={baseName}>
      <Box>
        <CssBaseline />
        <Gate id="shell" />
        <Gate id="main" />
        <UIShell
          title={title}
          toolbarContentLeft={toolbar.contentLeft}
          toolbarContentRight={toolbar.contentRight}
        >
          {createComponents(routes.before)}
          <LayoutRoutes items={routes.items} />
          {createComponents(routes.after)}
        </UIShell>
      </Box>
    </BrowserRouter>
  );
};
